import { render, staticRenderFns } from "./addnews.vue?vue&type=template&id=47e6b423&scoped=true&"
import script from "./addnews.vue?vue&type=script&lang=js&"
export * from "./addnews.vue?vue&type=script&lang=js&"
import style0 from "./addnews.vue?vue&type=style&index=0&id=47e6b423&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e6b423",
  null
  
)

export default component.exports